export default __webpack_public_path__ + "static/homepage-c7140942a0de9039dada83fa8c99ed3b.gif";